import React, { useCallback, useEffect, useState } from "react";
import { Tag, message } from "antd";

import { WrappedFormCompetence } from "./formCompetence";
import { remove, select } from "../actions/dimensionsAndType";
import { downloadFile } from "../../../components/util";
import { QmDimensionTable } from "../components/qmTable";
import { ICompetence, ICompetenceListResponse } from "./types";
import { Utilitaries } from "../../../business";
import { ColumnProps, PaginationConfig, SorterResult } from "antd/lib/table";
import { ITableFilter, ITableSort, QmKeyObject } from "../components/types";

const listName = "competencias";

const REPORT_PARAMS = {
    accao: "lista",
    lista: listName,
    campos: "tipo_competencia:300:Tipo de competência;designacao:400:Competência;contribui_qv:100:Contribui QV;",
    titulo: "Competências",
};

export function Competence() {
    const [dataSource, setDataSource] = useState<ICompetence[]>([]);
    const [loadingData, setLoadingData] = useState(true);
    const [showDeleteRecords, setShowDeleteRecords] = useState(false);
    const [filter, setFilter] = useState<ITableFilter>({
        pagination: {
            page: 1,
            perPage: 0,
        },
        filter: {},
    });
    const [editRow, setEditRow] = useState<ICompetence | null>(null);
    const [showModalNew, setShowModalNew] = useState(false);

    /** get tipos requisitos from the server */
    const loadData = useCallback(() => {
        setLoadingData(true);
        select({
            accao: "lista",
            lista: listName,
            pagina: 1,
            resultados_pagina: 0,
            mostra_lista_eliminados: showDeleteRecords,
        })
            .then((responses: ICompetenceListResponse) => {
                const list: ICompetence[] = Utilitaries.toArray(responses.linha);
                const data = list.map((item) => {
                    return {
                        ...item,
                        designacao: typeof item.designacao === "object" ? "" : item.designacao,
                        versao: typeof item.versao === "object" ? "" : item.versao,
                        n_inc_cri_neg: typeof item.n_inc_cri_neg === "object" ? "" : item.n_inc_cri_neg,
                        n_inc_cri_posi: typeof item.n_inc_cri_posi === "object" ? "" : item.n_inc_cri_posi,
                        n_sugests: typeof item.n_sugests === "object" ? "" : item.n_sugests,
                    };
                });

                setDataSource(data);
                setLoadingData(false);
            })
            .catch(() => {
                message.error("Ocorreu um erro ao carregar os tipos de requisitos.");
            });
    }, [showDeleteRecords]);

    useEffect(() => {
        loadData();
    }, [loadData]);

    function handleEdit(row: ICompetence) {
        setEditRow(row);
    }

    function deleteRow(id: string) {
        remove({
            accao: "eliminar",
            lista: listName,
            chave1: id,
        }).then((sucess) => {
            if (sucess) {
                message.success("Linha eliminada com sucesso");
                loadData();
            } else {
                message.error("Ocorreu um erro");
            }
        });
    }

    async function onExportList(type: "pdf" | "xls") {
        const params = {
            ...REPORT_PARAMS,
            filter,
            saida: type,
            downloadInBrowser: true,
        };
        await downloadFile("gerelistas.php", params);
    }

    function toggleShowDelete(value: boolean) {
        setShowDeleteRecords(value);
    }

    function handleNew() {
        setShowModalNew(true);
    }

    function handleCloseNew(reload?: boolean) {
        if (reload) {
            loadData();
        }
        setShowModalNew(false);
    }

    function handleCloseEdit(reload?: boolean) {
        if (reload) {
            loadData();
        }
        setEditRow(null);
    }

    /** for search results in table */

    function handleTableChange(
        _: PaginationConfig,
        filters: Partial<Record<keyof ICompetence, string[]>>,
        sorter: SorterResult<ICompetence>
    ) {
        const objFilter: QmKeyObject = {};

        if (filters) {
            Object.entries(filters).forEach(([key, val]) => {
                if (val && val[0]) objFilter[key] = val[0];
            });
        }

        let sortObj: ITableSort | null = null;
        if (sorter.columnKey && sorter.order) {
            sortObj = {
                sorterBy: sorter.columnKey,
                sorterOrder: sorter.order,
            };
        }

        setFilter((state) => ({
            ...state,
            pagination: {
                ...state.pagination,
                page: 1,
            },
            filter: objFilter,
            sorter: sortObj ?? undefined,
        }));
    }
    /****************************** */

    const columns: ColumnProps<ICompetence>[] = [
        {
            title: "Tipo de competência",
            dataIndex: "tipo_competencia",
            width: "20%",
            ...QmDimensionTable.columnsSearch("tipo_competencia"),
        },
        {
            title: "Competência",
            dataIndex: "designacao",
            width: "50%",
            ...QmDimensionTable.columnsSearch("tipo_competencia"),
        },
        {
            title: "Contribui QV",
            dataIndex: "contribui_qv",
            width: "15%",
            ...QmDimensionTable.columnsSearch("contribui_qv"),
            render: (text) => <Tag color={text === "Sim" ? "green" : "red"}>{text}</Tag>,
        },
        {
            title: "Ações",
            dataIndex: "actions",
            width: "25%",
            render: (_, record) =>
                record._eliminado_ === "t" ? (
                    <QmDimensionTable.actions
                        deleteRow={() => deleteRow(record.id_competencia)}
                        handleEdit={() => handleEdit(record)}
                    />
                ) : null,
        },
    ];

    return (
        <>
            <QmDimensionTable.list
                rowKey={(record) => record.id_competencia}
                loading={loadingData}
                columns={columns}
                dataSource={dataSource}
                exportList={onExportList}
                toogleShowDeletedRecords={toggleShowDelete}
                handleNew={handleNew}
                onChange={handleTableChange}
            />
            {showModalNew && <WrappedFormCompetence onClose={handleCloseNew} />}
            {editRow && <WrappedFormCompetence record={editRow} onClose={handleCloseEdit} />}
        </>
    );
}
